import React, { useEffect, useState } from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import useRequest from '../../../../axios/apis/useRequest.js'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import {
  Card,
  Form,
  OverlayTrigger,
  Tooltip,
} from '@themesberg/react-bootstrap'
import { Modal, Button } from '@themesberg/react-bootstrap'
import {
  productsChangeAttr,
  setAllPlans,
  setAllProduct,
} from '../../../../store/slices/products/productsSlice.js'
import { Wrapper } from './TrialForm.styled.jsx'
import { FormattedMessage } from 'react-intl'
import { ProductTrialType } from '../../../../const/product.js'
import SafeFormatMessage from '../../Shared/SafeFormatMessage/SafeFormatMessage.jsx'
import { BsFillQuestionCircleFill } from 'react-icons/bs'

const TrialForm = ({ setVisible, popupLabel }) => {
  const { changeProductTrialType, getProductList, getProductPlans } =
    useRequest()
  const [submitLoading] = useState()

  const dispatch = useDispatch()
  const params = useParams()
  const productId = params.id

  const listData = useSelector((state) => state.products.products)

  const trialData = listData[productId]

  useEffect(() => {
    if (!listData) {
      let query = `?page=1&pageSize=50&filters[0].Field=SearchTerm`
      ;(async () => {
        const productList = await getProductList(query)
        dispatch(setAllProduct(productList.data.data.items))
      })()
    }
  }, [])

  const createValidation = {
    trialType: Yup.number().required(
      <SafeFormatMessage id="This-field-is-required" />
    ),
    trialPlanId: Yup.string().test(
      'unit-validation',
      <SafeFormatMessage id="This-field-is-required" />,
      function (value) {
        const trialType = this.resolve(Yup.ref('trialType'))
        if (trialType == '2') {
          return value !== undefined && value !== ''
        }
        return true
      }
    ),
    trialPeriodInDays: Yup.number().test(
      'unit-validation',
      <SafeFormatMessage id="Trial-Period-In-Days-Required-Number" />,
      function (value) {
        const trialType = this.resolve(Yup.ref('trialType'))
        if (trialType == '2') {
          return value !== undefined && value !== ''
        }
        return true
      }
    ),
  }

  const validationSchema = Yup.object().shape(createValidation)

  const initialValues = {
    trialType: trialData ? trialData.trialType : '',
    plan: trialData ? trialData.plan : '',
    trialPeriodInDays: trialData ? trialData.trialPeriodInDays : '',
    isTrialPaymentDetailsRequired: trialData
      ? trialData.isTrialPaymentDetailsRequired
      : true,
  }

  const formik = useFormik({
    initialValues,
    validationSchema: validationSchema,

    onSubmit: async (values) => {
      if (formik.values.trialType == 2) {
        const productTrialType = await changeProductTrialType(productId, {
          trialType: parseInt(values.trialType),
          trialPlanId: formik.values.trialType == 2 ? values.trialPlanId : null,
          isTrialPaymentDetailsRequired: values.isTrialPaymentDetailsRequired,
          trialPeriodInDays:
            formik.values.trialType == 2
              ? parseInt(values.trialPeriodInDays)
              : null,
        })
        dispatch(
          productsChangeAttr({
            productId,
            attributes: {
              trialType: parseInt(values.trialType),
              trialPlanId: values.trialPlanId,
              trialPeriodInDays: parseInt(values.trialPeriodInDays),
              isTrialPaymentDetailsRequired:
                values.isTrialPaymentDetailsRequired,
            },
          })
        )
      } else if (formik.values.trialType == 1) {
        const productTrialType = await changeProductTrialType(productId, {
          trialType: parseInt(values.trialType),
        })
        dispatch(
          productsChangeAttr({
            productId,
            attributes: {
              trialType: parseInt(values.trialType),
              trialPlanId: '',
              trialPeriodInDays: 0,
            },
          })
        )
      } else if (formik.values.trialType == 3) {
        const productTrialType = await changeProductTrialType(productId, {
          trialType: parseInt(values.trialType),
          isTrialPaymentDetailsRequired: values.isTrialPaymentDetailsRequired,
        })
        dispatch(
          productsChangeAttr({
            productId,
            attributes: {
              trialType: parseInt(values.trialType),
              trialPlanId: '',
              trialPeriodInDays: 0,
              isTrialPaymentDetailsRequired:
                values.isTrialPaymentDetailsRequired,
            },
          })
        )
      }

      setVisible && setVisible(false)
      setVisible && setVisible(false)
    },
  })

  let planOptions
  if (listData[productId]?.plans) {
    planOptions = Object.values(listData[productId].plans)
      .filter((item) => item.isPublished === true)
      .map((item, index) => ({
        value: item.id,
        label: item.displayName,
      }))
  } else {
    planOptions = []
  }

  useEffect(() => {
    ;(async () => {
      if (listData[productId]) {
        if (!listData[productId].plans) {
          const planData = await getProductPlans(productId)
          dispatch(
            setAllPlans({
              productId: productId,
              data: planData.data.data,
            })
          )
        }
      }
    })()
  }, [productId])

  return (
    <Wrapper>
      <Form onSubmit={formik.handleSubmit}>
        <Modal.Header>
          <Modal.Title className="h6">{popupLabel}</Modal.Title>
          <Button
            variant="close"
            aria-label="Close"
            onClick={() => setVisible(false)}
          />
        </Modal.Header>
        <Modal.Body>
          <div>
            <Form.Group className="mb-3">
              <Form.Label>
                <SafeFormatMessage id="Trial-Type" />{' '}
                <span style={{ color: 'red' }}>*</span>
              </Form.Label>
              <select
                className="form-control"
                name="trialType"
                id="trialType"
                value={formik.values.trialType}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              >
                <option value="">
                  <SafeFormatMessage id="Select-Option" />{' '}
                </option>
                {Object.entries(ProductTrialType).map(([value, label]) => (
                  <option key={value} value={value}>
                    {label && label.value}
                  </option>
                ))}
              </select>
              {formik.touched.trialType && formik.errors.trialType && (
                <Form.Control.Feedback
                  type="invalid"
                  style={{ display: 'block' }}
                >
                  {formik.errors.trialType}
                </Form.Control.Feedback>
              )}
            </Form.Group>
          </div>

          {formik.values.trialType == 2 && (
            <div>
              <Form.Group className="mb-3">
                <Form.Label>
                  <SafeFormatMessage id="Trial-Plan" />{' '}
                  <span style={{ color: 'red' }}>*</span>
                </Form.Label>
                <select
                  className="form-control"
                  name="trialPlanId"
                  id="trialPlanId"
                  value={
                    formik.values.trialType == 2
                      ? formik.values.trialPlanId
                      : ''
                  }
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  disabled={!productId}
                >
                  <option value="">
                    <SafeFormatMessage id="Select-Option" />
                  </option>
                  {planOptions?.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
                {formik.touched.trialPlanId && formik.errors.trialPlanId && (
                  <Form.Control.Feedback
                    type="invalid"
                    style={{ display: 'block' }}
                  >
                    {formik.errors.trialPlanId}
                  </Form.Control.Feedback>
                )}
              </Form.Group>
            </div>
          )}
          {formik.values.trialType == 2 && (
            <div>
              <Form.Group className="mb-3">
                <Form.Label>
                  <SafeFormatMessage id="Trial-Period-In-Days" />{' '}
                  <span style={{ color: 'red' }}>*</span>
                </Form.Label>
                <input
                  className="form-control"
                  type="text"
                  id="trialPeriodInDays"
                  name="trialPeriodInDays"
                  onChange={formik.handleChange}
                  value={
                    formik.values.trialType == 2
                      ? formik.values.trialPeriodInDays
                      : ''
                  }
                />

                {formik.touched.trialPeriodInDays &&
                  formik.errors.trialPeriodInDays && (
                    <Form.Control.Feedback
                      type="invalid"
                      style={{ display: 'block' }}
                    >
                      {formik.errors.trialPeriodInDays}
                    </Form.Control.Feedback>
                  )}
              </Form.Group>
            </div>
          )}
          {formik.values.trialType != 1 && (
            <div>
              <Form.Group className="mb-3">
                <Card>
                  <Card.Body className="py-2 px-3 d-flex justify-content-between">
                    <Form.Label>
                      <SafeFormatMessage
                        id={'Payment-Details-Collection-During-Trial'}
                      />{' '}
                      <OverlayTrigger
                        trigger={['hover', 'focus']}
                        placement="top"
                        overlay={
                          <Tooltip>
                            <SafeFormatMessage id="Payment-Details-Collection-During-Trial-desc" />
                          </Tooltip>
                        }
                      >
                        <span>
                          <BsFillQuestionCircleFill />
                        </span>
                      </OverlayTrigger>
                    </Form.Label>
                    <Form.Check
                      type="checkbox"
                      id="isTrialPaymentDetailsRequired"
                      name="isTrialPaymentDetailsRequired"
                      checked={formik.values.isTrialPaymentDetailsRequired}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.isTrialPaymentDetailsRequired &&
                      formik.errors.isTrialPaymentDetailsRequired && (
                        <Form.Control.Feedback
                          type="invalid"
                          style={{ display: 'block' }}
                        >
                          {formik.errors.isTrialPaymentDetailsRequired}
                        </Form.Control.Feedback>
                      )}
                  </Card.Body>
                </Card>
              </Form.Group>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" type="submit" disabled={submitLoading}>
            <SafeFormatMessage id="Submit" />
          </Button>
          <Button
            variant="link"
            className="text-gray "
            onClick={() => setVisible(false)}
          >
            <SafeFormatMessage id="Close" />
          </Button>
        </Modal.Footer>
      </Form>
    </Wrapper>
  )
}

export default TrialForm
